<h2 mat-dialog-title>Your changes have not been saved. Do you want to save before exiting?</h2>

<mat-dialog-actions>
  <button mat-button type="button" class="btn btn-lg btn-primary continue-btn" (click)="onSaveExit()">Save</button>
  <button mat-button type="button" class="btn btn-lg btn-primary continue-btn" (click)="onExit()">Don't Save</button>
  <button mat-button type="button" class="btn btn-lg btn-primary continue-btn" (click)="onCancel()">Cancel</button>
</mat-dialog-actions>
